// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2QO-u","content":"LayoutSettings_content__3plyj"};